// Watch Later Action Types
export const WatchLaterTypes = {
  // Fetch watch later
  FETCH_WATCH_LATER_REQUEST: 'WATCH_LATER_FETCH_REQUEST',
  FETCH_WATCH_LATER_SUCCESS: 'WATCH_LATER_FETCH_SUCCESS',
  FETCH_WATCH_LATER_FAILURE: 'WATCH_LATER_FETCH_FAILURE',
  
  // Add video to watch later
  ADD_TO_WATCH_LATER_REQUEST: 'WATCH_LATER_ADD_VIDEO_REQUEST',
  ADD_TO_WATCH_LATER_SUCCESS: 'WATCH_LATER_ADD_VIDEO_SUCCESS',
  ADD_TO_WATCH_LATER_FAILURE: 'WATCH_LATER_ADD_VIDEO_FAILURE',
  
  // Remove video from watch later
  REMOVE_FROM_WATCH_LATER_REQUEST: 'WATCH_LATER_REMOVE_VIDEO_REQUEST',
  REMOVE_FROM_WATCH_LATER_SUCCESS: 'WATCH_LATER_REMOVE_VIDEO_SUCCESS',
  REMOVE_FROM_WATCH_LATER_FAILURE: 'WATCH_LATER_REMOVE_VIDEO_FAILURE',
  
  // Update video timestamp
  UPDATE_TIMESTAMP_REQUEST: 'WATCH_LATER_UPDATE_TIMESTAMP_REQUEST',
  UPDATE_TIMESTAMP_SUCCESS: 'WATCH_LATER_UPDATE_TIMESTAMP_SUCCESS',
  UPDATE_TIMESTAMP_FAILURE: 'WATCH_LATER_UPDATE_TIMESTAMP_FAILURE',
  
  // Reorder videos in watch later
  REORDER_WATCH_LATER_REQUEST: 'WATCH_LATER_REORDER_REQUEST',
  REORDER_WATCH_LATER_SUCCESS: 'WATCH_LATER_REORDER_SUCCESS',
  REORDER_WATCH_LATER_FAILURE: 'WATCH_LATER_REORDER_FAILURE',
  
  // UI related actions
  SHOW_TOAST: 'WATCH_LATER_SHOW_TOAST',
  
  // Player related actions
  LOAD_WATCH_LATER_FOR_PLAYBACK_REQUEST: 'WATCH_LATER_LOAD_FOR_PLAYBACK_REQUEST',
  LOAD_WATCH_LATER_FOR_PLAYBACK_SUCCESS: 'WATCH_LATER_LOAD_FOR_PLAYBACK_SUCCESS',
  LOAD_WATCH_LATER_FOR_PLAYBACK_FAILURE: 'WATCH_LATER_LOAD_FOR_PLAYBACK_FAILURE',
  SET_WATCH_LATER_PLAYBACK_INDEX: 'WATCH_LATER_SET_PLAYBACK_INDEX',
  NEXT_WATCH_LATER_VIDEO: 'WATCH_LATER_NEXT_VIDEO',
  PREVIOUS_WATCH_LATER_VIDEO: 'WATCH_LATER_PREVIOUS_VIDEO',
  TOGGLE_WATCH_LATER_AUTOPLAY: 'WATCH_LATER_TOGGLE_AUTOPLAY',
  CLEAR_WATCH_LATER_PLAYBACK: 'WATCH_LATER_CLEAR_PLAYBACK'
};
